import React, { forwardRef, useEffect, useState } from 'react';
import { clearSuchvorschlaege } from '../../../../redux/actions/adresse';
import { connect } from 'react-redux';
import Validationtip from '../../../validationtip/Validationtip';
import { StateModel } from '../../../../redux/store';

interface InputFieldTextProps {
  id?: string;
  label?: string;
  name?: string;
  classes?: string;
  inputType?: string;
  required?: boolean;
  maxlength?: number;
  onChangeHandler: (value: string) => void;
  onBlurHandler?: () => void;
  parentFocusHandler?: (value: string) => void;
  value?: string;
  resetValue?: string;
  autocompleteField?: any;
  autocompleteFormat?: any;
  autocompleteHandler?: any;
  suchvorschlaege?: any;
  clearSuchvorschlaege?: any;
  readonly?: boolean;
  tooltip?: string;
  activeNotificationComponent?: string; //Dient zur Anzeige von Tip in einem bestimmten Bereich
  focusAfterTip?: () => void;
  onKeyDownHandler?: (event: any) => void;
}

const InputFieldText = forwardRef<HTMLInputElement, InputFieldTextProps>(
  (
    {
      id,
      label,
      name,
      classes = '',
      inputType = 'text',
      required = false,
      maxlength,
      onChangeHandler,
      onBlurHandler,
      parentFocusHandler,
      value,
      resetValue = '',
      autocompleteField,
      autocompleteFormat,
      autocompleteHandler,
      suchvorschlaege,
      clearSuchvorschlaege,
      readonly = false,
      tooltip = '',
      focusAfterTip: focusAfterValidationTip,
      activeNotificationComponent,
      onKeyDownHandler,
    },
    ref
  ) => {
    const [showList, setShowList] = useState(false);

    useEffect(() => {
      if (value === undefined) onChangeHandler(resetValue);
    }, [value]);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.value.trim() === '') {
        autocompleteFormat && clearSuchvorschlaege();
      }
      onChangeHandler(event.target.value);
    };

    const onBlur = () => {
      onBlurHandler && onBlurHandler();
      suchvorschlaege && clearSuchvorschlaege();
      setShowList(false);
    };

    const onListClick = (suchvorschlag: { [x: string]: string }) => {
      autocompleteHandler
        ? autocompleteHandler(suchvorschlag)
        : onChangeHandler(suchvorschlag[autocompleteField]);
      setShowList(false);
      parentFocusHandler && parentFocusHandler('');
      clearSuchvorschlaege();
    };

    const onFocusHandler = () => {
      setShowList(true);
      parentFocusHandler && name && parentFocusHandler(name);
      clearSuchvorschlaege();
    };

    return (
      <div className={`floating form-group ${classes}`} onBlur={onBlur}>
        <Validationtip
          fieldName={name ?? ''}
          focusAfterRender={focusAfterValidationTip}
          activeNotificationComponent={activeNotificationComponent}
          elementValue={value}
        >
          <input
            title={tooltip}
            id={id}
            type={inputType}
            placeholder=' '
            required={required}
            maxLength={maxlength}
            value={value ?? ''}
            onChange={event => onChange(event)}
            onFocus={() => onFocusHandler()}
            readOnly={readonly}
            ref={ref}
            onKeyDown={onKeyDownHandler}
          />
          <label className='floating-label'>{label}</label>

          {(autocompleteField || autocompleteFormat) &&
            showList &&
            suchvorschlaege &&
            suchvorschlaege.length > 0 && (
              <ul className='suchvorschlaege'>
                {suchvorschlaege.map(
                  (suchvorschlag: any, index: React.Key | null | undefined) => {
                    return (
                      <li
                        className='lisuchvorschlaege'
                        key={index}
                        onMouseDown={() => onListClick(suchvorschlag)}
                      >
                        {' '}
                        {autocompleteFormat
                          ? React.cloneElement(autocompleteFormat, {
                              suchvorschlag: suchvorschlag,
                            })
                          : suchvorschlag[autocompleteField]}{' '}
                      </li>
                    );
                  }
                )}
              </ul>
            )}
        </Validationtip>
      </div>
    );
  }
);

InputFieldText.displayName =
  InputFieldText.defaultProps?.name ?? 'InputFieldText';

const mapStateToProps = (state: StateModel) => ({
  notifications: state.Notifications.messageList,
});

export default connect(mapStateToProps, { clearSuchvorschlaege }, null, {
  forwardRef: true,
})(InputFieldText);
